import {Injectable} from '@angular/core';
import {RestService} from "./rest.service";

@Injectable({
  providedIn: 'root'
})
export class RoleService extends RestService {
  endpoint(): string {
    return "roles";
  }
  param1(): string {
    return "";
  }

  param2(): string {
    return "";
  }

  param3(): string {
    return "";
  }
}
